export interface ILifeEvent {
    id: number,
    patientID: number,
    date: Date,
    title: string
    description: string
}

export class LifeEvent {
    public id: number;
    public patientID: number;
    public date: Date;
    public title: string;
    public description: string;

    constructor(input: ILifeEvent) {
        this.id = input.id;
        this.patientID = input.patientID;
        this.date = new Date(input.date);
        this.title = input.title;
        this.description = input.description;
    }
}
